import React, { useState, useEffect, useRef } from "react";
import { showAlert } from "../utils/Helper";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const API_BASE = API_ROOT ? (API_ROOT.endsWith("/api") ? API_ROOT : `${API_ROOT}/api`) : "/api";

export default function ForgotPassword() {
  const [login, setLogin] = useState("");
  const [moduleId, setModuleId] = useState("");
  const [modules, setModules] = useState([]);
  const [loadingModules, setLoadingModules] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const moduleIdRef = useRef(moduleId);
  moduleIdRef.current = moduleId;

  const canSubmit = /^\d{10}$/.test(login) && Boolean(moduleId) && !submitting;

  useEffect(() => {
    if (!/^\d{10}$/.test(login)) {
      setModules([]);
      setModuleId("");
      return;
    }

    let cancelled = false;

    const load = async () => {
      try {
        setLoadingModules(true);
        const res = await fetch(`${API_BASE}/auth/forgot-modules?login=${encodeURIComponent(login)}`);
        const data = await res.json();
        if (cancelled) return;

        if (!res.ok) throw new Error(data?.message || "Failed to load modules");

        const list = Array.isArray(data) ? data : [];
        setModules(list);
        if (!list.some((item) => String(item.ModuleID) === String(moduleIdRef.current))) {
          setModuleId("");
        }
      } catch (err) {
        if (cancelled) return;
        setModules([]);
        setModuleId("");
        showAlert(err.message || "Failed to load modules", null, "error");
      } finally {
        if (!cancelled) setLoadingModules(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, [login]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!/^\d{10}$/.test(login)) {
      showAlert("Mobile must be exactly 10 digits", null, "error");
      return;
    }

    if (!moduleId) {
      showAlert("Please select a module.", null, "error");
      return;
    }

    try {
      setSubmitting(true);
      const res = await fetch(`${API_BASE}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ login, moduleId })
      });

      const data = await res.json();
      if (!res.ok) {
        throw new Error(data?.message || "Password reset failed");
      }

      showAlert(
        data?.message ||
          "Your Password has been Reset and OTP sent to your Registered Mobile. Use your Mobile Number as User Name and OTP as password to Login. Please change your password immediately.",
        "/login",
        "success"
      );
    } catch (err) {
      showAlert(err.message || "Password reset failed", null, "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container mt-4" style={{ textAlign: "left" }}>
      <h3 className="ctitle">Reset Password</h3>
      <div className="col-lg-6 col-md-8">
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">User Login (Mobile)</label>
            <input
              className="form-control"
              name="Login"
              type="text"
              placeholder="Mobile...*"
              value={login}
              onChange={(e) => {
                const next = e.target.value.replace(/\D/g, "").slice(0, 10);
                setLogin(next);
              }}
              required
            />
            <small className="text-muted">Enter 10-digit registered mobile number.</small>
          </div>

          <div className="mb-3">
            <label className="form-label">Select Module</label>
            <select
              className="form-control"
              name="ModuleID"
              value={moduleId}
              onChange={(e) => setModuleId(e.target.value)}
              disabled={loadingModules || !/^\d{10}$/.test(login)}
              required
            >
              <option value="">-- Select Module --</option>
              {modules.map((option) => (
                <option key={`${option.ModuleID}-${option.Module}`} value={option.ModuleID}>
                  {option.Module}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <button type="submit" className="btn btn-primary" disabled={!canSubmit}>
              {submitting ? "Resetting..." : "Reset Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
